// import React from 'react';
import logoBrown from '../../assets/images/logo-nav.webp';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div className="navbar-outer">
      <nav className="navbar">
        <div className="navbar-left" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src={logoBrown} alt="MyNaksh Logo" className="navbar-logo" />
          <h2 className="navbar-title">MyNaksh</h2>
        </div>
        <button
          className="navbar-btn"
          aria-label="Download App"
          onClick={() => {
            window.open('https://play.google.com/store/apps/details?id=com.astrology.mynaksh', '_blank');
          }}
        >
          Download App
        </button>
      </nav>
    </div>
  );
};

export default Navbar;